module.exports = __webpack_public_path__ + "img/icon_map_3_5_yj_hg.0308fa51.png";